import axios from "axios";


export const api = axios.create({
  baseURL: "/api", // Ajuste para a URL do seu backend
  headers: {
    "Content-Type": "application/json",
  },
});

// export const api = axios.create({
//   baseURL: "http://localhost:3000/api", // Ajuste para a URL do seu backend
//   headers: {
//     "Content-Type": "application/json",
//   },
// });